import { motion } from 'framer-motion';
import { WhyGrid } from '../components/home/WhyChooseUs';
import { COMPANY } from '../data/site';
import { useEnquiry } from '../context/EnquiryContext';
import { ArrowUpRight } from 'lucide-react';

export default function WhyChooseUsPage() {
  const { open } = useEnquiry();
  return (
    <main data-testid="why-choose-us-page" className="pt-40 pb-32 min-h-screen">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <p className="text-[10px] tracking-[0.3em] text-terra font-medium mb-6">THE PRAKRUTI WAY</p>
        <motion.h1
          initial={{ opacity: 0, y: 34 }} animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="font-heading font-extrabold tracking-tighter leading-[0.95] text-5xl sm:text-7xl text-ink mb-8"
          data-testid="why-page-headline"
        >
          Why Choose Us
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.15 }}
          className="text-base lg:text-lg text-ink/60 leading-relaxed max-w-2xl mb-16"
        >
          Nine reasons families and investors trust Prakruti with their land — from the first site visit
          to registration and beyond.
        </motion.p>

        <WhyGrid />

        <motion.div
          initial={{ opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }} transition={{ duration: 0.8 }}
          className="mt-24 bg-moss text-sand p-10 lg:p-16 text-center"
          data-testid="why-page-tagline"
        >
          <p className="font-serif italic text-3xl sm:text-4xl lg:text-5xl leading-snug max-w-3xl mx-auto">
            “{COMPANY.tagline}”
          </p>
          <button onClick={() => open()} data-testid="why-page-enquiry-btn"
            className="mt-10 bg-terra text-white text-[11px] font-medium tracking-[0.2em] px-10 py-4 inline-flex items-center gap-2 hover:bg-sand hover:text-ink transition-colors duration-300">
            SEND AN ENQUIRY <ArrowUpRight size={14} />
          </button>
        </motion.div>
      </div>
    </main>
  );
}
